import { authenticatedRequest } from './apiClient';
import { ApiIncidentsResponse } from '../types/api';
import { Accident } from '../types';

export interface IncidentsFetchResult {
  accidents: Accident[];
  fetchedAt: Date;
  error?: string;
}

function toAccident(raw: ApiIncidentsResponse['incidents'][number]): Accident {
  return {
    id: raw.id,
    title: raw.title,
    description: raw.description,
    severity: raw.severity,
    location: {
      lat: raw.location.lat,
      lng: raw.location.lng,
      address: raw.location.address || '',
    },
    timestamp: new Date(raw.timestamp),
    type: raw.type,
    affectedLanes: raw.affectedLanes,
    estimatedClearTime: raw.estimatedClearTime
      ? new Date(raw.estimatedClearTime)
      : undefined,
    source: raw.source,
    submittedBy: raw.submittedBy,
    helpfulnessRating: raw.helpfulnessRating,
  };
}

export async function fetchIncidents(
  north: number,
  south: number,
  east: number,
  west: number,
  bypassCache = false
): Promise<IncidentsFetchResult> {
  try {
    const params = new URLSearchParams({
      north: String(north),
      south: String(south),
      east: String(east),
      west: String(west),
    });
    if (bypassCache) params.set('bypassCache', 'true');

    const data = await authenticatedRequest<ApiIncidentsResponse>(
      `/incidents?${params.toString()}`
    );

    return {
      accidents: (data.incidents || []).map(toAccident),
      fetchedAt: data.fetched_at ? new Date(data.fetched_at) : new Date(),
    };
  } catch (err) {
    return {
      accidents: [],
      fetchedAt: new Date(),
      error: err instanceof Error ? err.message : 'Failed to fetch incidents',
    };
  }
}
